import App, { Container } from 'next/app';
import React from 'react';
import withReduxStore from 'src/with-redux-store';
import { Provider } from 'react-redux';
import { appWithTranslation } from '../config/i18n';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from 'styles-js/globalStyles';

import 'styles/base.scss';

// Help Scout Beacon
// Script could have been added to _document.js but is quite long. Importing it
// here means we can use ES6 and it is bundled in _app.js
if (typeof window !== 'undefined') {
  require('scripts/helpscoutBeacon');
}

// Extract our Sass variables into a JS object
const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../styles/lib/index.scss');

class MyApp extends App {
  render() {
    const { Component, pageProps, store } = this.props;

    return (
      <Container>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <React.Fragment>
              <GlobalStyles />
              <Component {...pageProps} />
            </React.Fragment>
          </ThemeProvider>
        </Provider>
      </Container>
    );
  }
}

export default appWithTranslation(withReduxStore(MyApp));
